'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _GetStartedInput = require('./GetStartedInput.css');

var _GetStartedInput2 = _interopRequireDefault(_GetStartedInput);

var _components = require('../../components');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GetStartedInput = (_dec = (0, _reactCssModules2.default)(_GetStartedInput2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(GetStartedInput, _Component);

  function GetStartedInput(props) {
    (0, _classCallCheck3.default)(this, GetStartedInput);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GetStartedInput.__proto__ || (0, _getPrototypeOf2.default)(GetStartedInput)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(GetStartedInput, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'container-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'container' },
          _react2.default.createElement(
            'div',
            { styleName: 'container-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'form-wrap' },
              _react2.default.createElement(
                'div',
                { styleName: 'tagline' },
                'Find sustainably-invested mutual funds and ETFs'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'link-wrap' },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.routes.clean,
                    bigbutton: true,
                    title: _config2.default.getStartedInput.title
                  },
                  _config2.default.getStartedInput.label,
                  _react2.default.createElement(_components.LinkIcon, { faclass: _config2.default.getStartedInput.faclass })
                )
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement('br', null),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'div',
                { styleName: 'tagline' },
                'Search for funds from your 401(k), retirement plan, or personal portfolio'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'autocomplete-wrap' },
                _react2.default.createElement(_components.AutocompleteSearch, null)
              )
            )
          )
        )
      );
    }
  }]);
  return GetStartedInput;
}(_react.Component)) || _class);
exports.default = GetStartedInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/GetStartedInput/GetStartedInput.js
// module id = 1357
// module chunks = 0